export const SIMPLE = "default";
export const OIL_REST_HOTEL = "oil_shop";
export const DRIVETHRU = "drivethru";
export const WALK_OUT = "walkout";
export const STRAIGHT_CAR = "straightcar";
export const MAX_RECORDS_FROM_INDEXEDDB = 100;
